import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Helpers
import { getTemplateServiceByDeviceID } from '../template_helpers';
import { getEvWorkingState, type StatusIndicatorWorkingStates } from './ev_charger_helpers';
//Types
import type { TemplateService, VCInterfaceStatus } from 'src/types/VirtualComponents';
import type { Device } from 'src/types/Device';

export type AutoChargingMode = {
	label: string;
	labelIcon: string;
	labelIconColor: '--color-primary' | '--color-success';
	btnTitle: string;
	btnVariant: 'primary' | 'success';
	btnState: boolean;
	btnID: number;
	btnDisabled: boolean;
};

export const getAutoChargeMode = (
	deviceID: Device['id'],
	statuses: VCInterfaceStatus[],
): AutoChargingMode => {
	const $format = get(format);
	const templateService: TemplateService = getTemplateServiceByDeviceID(deviceID);
	const autoCharging: boolean = templateService?.settings?.auto_charge;
	const startCharging: VCInterfaceStatus = statuses.find((i) => i?.role === 'start_charging');
	const autoChargingMode: string = autoCharging ? 'auto' : 'manual';
	const workState: StatusIndicatorWorkingStates = getEvWorkingState(
		statuses.find((i) => i?.role === 'work_state')?.event,
	)?.state;

	let label: string = $format('label_auto_mode', {
		default: 'Auto Mode',
	});
	let labelIcon: string = 'far fa-bolt-auto';
	let labelIconColor: AutoChargingMode['labelIconColor'] = '--color-success';
	let btnTitle: string = $format('label_enable_charging', {
		default: 'Enable charging',
	});
	let btnDisabled: boolean = /^(idle|error|waiting)$/.test(workState);
	let btnState: boolean = autoChargingMode === 'auto' && btnDisabled ? true : startCharging.event;
	let btnVariant: AutoChargingMode['btnVariant'] = 'success';

	if (autoChargingMode === 'manual') {
		label = $format('label_manual_mode', {
			default: 'Manual mode',
		});
		labelIcon = 'far fa-hand-back-point-up';
		labelIconColor = '--color-primary';
		btnVariant = 'primary';
	}
	if (workState === 'idle') {
		btnTitle = $format('label_plug_disconnected', {
			default: 'Plug disconnected',
		});
	} else if (btnState) {
		btnTitle = $format('label_disable_charging', {
			default: 'Disable charging',
		});
	}
	return {
		label,
		labelIcon,
		labelIconColor,
		btnTitle,
		btnVariant,
		btnState,
		btnDisabled,
		btnID: startCharging.id,
	};
};
